"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const graphql_1 = require("../..");
exports.suggestNextVersion = graphql_tag_1.default `
  query suggestNextVersion(
    $version: String!,
    $releaseType: String
  ) {
    suggestNextVersion(
      version: $version,
      releaseType: $releaseType
    )
  }
`;
exports.emailTemplateVersion = graphql_tag_1.default `
  query emailTemplateVersion($id: ID, $emailTemplateId: ID!, $version: String) {
    emailTemplateVersion(id: $id, emailTemplateId: $emailTemplateId, version: $version) {
      template {
        id
        name
        stagingVersion {
          id
          version
          createdAt
        }
        productionVersion {
          id
          version
          createdAt
        }
      }
      blocks {
        ...emailTemplateBlockDetails
      }
      ...emailTemplateVersionDetails
    }
  }
  ${graphql_1.emailTemplateVersionDetails}
  ${graphql_1.emailTemplateBlockDetails}
`;
exports.emailTemplateVersions = graphql_tag_1.default `
  query emailTemplateVersions(
    $emailTemplateId: ID,
    $skip: Int,
    $take: Int
  ) {
    emailTemplateVersionsCount(
      emailTemplateId: $emailTemplateId
    )
    emailTemplateVersions(
      emailTemplateId: $emailTemplateId,
      skip: $skip,
      take: $take
    ) {
      ...emailTemplateVersionDetails
    }
  }
  ${graphql_1.emailTemplateVersionDetails}
`;
//# sourceMappingURL=emailTemplateVersions.js.map